import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSAvantioStore = GenericCollectionFactory("PMS-AVANTIO-INTEGRATION", "id");
